import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { FmLoadingPageService } from '../../shared/services/fm-loading-page.service';
import { PassdataService } from '../services/passdata.service';
import { RecombinationsService } from '../services/recombinations.service';

export const RecombinationResolveService: ResolveFn<any> = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const recombinationService = inject(RecombinationsService);
  const router = inject(Router);
  const passData = inject(PassdataService);
  const fmLoadingPageService = inject(FmLoadingPageService);
  const errorHandlerService = inject(ErrorHandlerService);

  const recombinationExchangeResponse = passData.getRecombinationDataCache();

  if (recombinationExchangeResponse != null) {
    return recombinationExchangeResponse.recombinations;
  } else {
    return recombinationService.getRecombinationsExchange().pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error, _caught) => {
        fmLoadingPageService.isLoaderRequesting.set(false);
        const errorObject = error;
        errorHandlerService.setErrorObj(errorObject);
        recombinationService.setRecombinationResponseData(errorObject);
        if (errorObject.status === 400) {
          router.navigate([router.url]);
        } else {
          router.navigate(['error']);
        }
        return of(error);
      }),
    );
  }
};
